module.exports = __webpack_public_path__ + "static/wearedevelopers2018-ea8725d49f4af17ff152e004fb9c4551.jpeg";